(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sg-theme-polish"]) return;
  try {
    
document.addEventListener('click',function(event){document.querySelectorAll('.sg-nav__department[open]').forEach(function(detail){if(!detail.contains(event.target))detail.open=false;});});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.sg-nav__department[open]').forEach(function(detail){detail.open=false;detail.querySelector('summary').focus();});}});
document.addEventListener('toggle',function(event){if(event.target.matches&&event.target.matches('.sg-nav__department[open]')){document.querySelectorAll('.sg-nav__department[open]').forEach(function(detail){if(detail!==event.target)detail.open=false;});}},true);



/* Desktop: open department panels on hover (mouse only); click and keyboard still work */
(function(){
  if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  document.querySelectorAll('.sg-nav__department').forEach(function(d){
    var t,byHover=false,s=d.querySelector('summary');
    d.addEventListener('mouseenter',function(){clearTimeout(t);t=setTimeout(function(){if(!d.open){d.open=true;byHover=true;}},120);});
    d.addEventListener('mouseleave',function(){clearTimeout(t);t=setTimeout(function(){d.open=false;byHover=false;},200);});
    if(s)s.addEventListener('click',function(e){if(byHover&&d.open){e.preventDefault();byHover=false;}});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
